const TYPES = {
    VISITOR : "visitor",
    DELIVERY : "delivery"
}

export const Notifics = [{
    id: 1,
    title: "Ashish wants to visit your place, do want to accept ?",
    type: TYPES.VISITOR,
},
{
    id: 2,
    title: "You have a parcel from Amazon, Do you want to sent it on your doorstep ?",
    type: TYPES.DELIVERY,
},
]